import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchWithTimeout } from "../../App";
import "../../index.css";
import "../../App.css";

const API_URL = process.env.REACT_APP_API_URL;

function AdminLogin() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await fetchWithTimeout(`${API_URL}/api/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ password }),
      }, 8000);

      const data = await res.json();

      if (!res.ok) {
        setError(data.error || "Login failed.");
        setLoading(false);
        return;
      }

      navigate("/admin");
    } catch (err) {
      setError(err.name === "AbortError" ? "Server not responding — check your connection." : "Something went wrong. Try again.");
      setLoading(false);
    }
  };

  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        <div style={{ textAlign: "center", marginBottom: "2rem" }}>
          <div style={logoWrapStyle}>
            <img
              src={`${process.env.PUBLIC_URL}/logo.png`}
              alt="Mama Bacamel"
              style={logoImgStyle}
              onError={(e) => { e.target.style.display = "none"; e.target.nextSibling.style.display = "block"; }}
            />
            <span style={{ display: "none", fontSize: "2.5rem" }}>🍝</span>
          </div>
          <h1 style={{ margin: "0.75rem 0 0", fontSize: "1.5rem", fontFamily: "'Playfair Display', Georgia, serif", color: "var(--text-main)" }}>
            Admin Panel
          </h1>
          <p style={{ margin: "0.3rem 0 0", color: "var(--text-muted)", fontSize: "0.88rem", fontStyle: "italic" }}>
            Mama Bacamel kitchen 🧡
          </p>
        </div>

        <form onSubmit={handleLogin}>
          <label style={labelStyle}>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={inputStyle}
            autoFocus
          />

          {error && (
            <div style={errorBoxStyle}>
              ⚠️ {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{ ...buttonStyle, opacity: loading ? 0.5 : 1, boxShadow: loading ? "none" : "0 4px 14px rgba(224, 123, 57, 0.35)" }}
          >
            {loading ? "Logging in..." : "Log In"}
          </button>
        </form>
      </div>
    </div>
  );
}

const pageStyle = {
  minHeight: "100vh",
  background: "var(--cream)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const cardStyle = {
  background: "var(--warm-white)",
  borderRadius: "16px",
  padding: "2.5rem",
  width: "100%",
  maxWidth: "380px",
  border: "1px solid var(--border)",
  boxShadow: "0 4px 24px rgba(92, 51, 23, 0.08)",
};

const logoWrapStyle = {
  width: "88px",
  height: "88px",
  margin: "0 auto",
  borderRadius: "50%",
  background: "radial-gradient(circle, rgba(250, 240, 220, 0.18) 0%, transparent 70%)",
  boxShadow: "0 0 24px rgba(224, 123, 57, 0.2), 0 0 48px rgba(200, 134, 10, 0.08)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
};

const logoImgStyle = {
  width: "80px",
  height: "80px",
  objectFit: "contain",
  borderRadius: "50%",
  filter: "drop-shadow(0 2px 6px rgba(59, 32, 16, 0.35))",
};

const labelStyle = {
  display: "block",
  fontWeight: "600",
  fontSize: "0.85rem",
  color: "var(--brown-mid)",
  marginBottom: "0.4rem",
  textTransform: "uppercase",
  letterSpacing: "0.04em",
};

const inputStyle = {
  display: "block",
  width: "100%",
  padding: "0.7rem 0.85rem",
  marginBottom: "1.25rem",
  borderRadius: "10px",
  border: "1.5px solid var(--border)",
  background: "var(--beige)",
  fontSize: "1rem",
  color: "var(--text-main)",
  boxSizing: "border-box",
  outline: "none",
};

const buttonStyle = {
  display: "block",
  width: "100%",
  background: "var(--orange)",
  color: "white",
  border: "none",
  padding: "0.75rem",
  borderRadius: "10px",
  fontSize: "1rem",
  fontWeight: "700",
  cursor: "pointer",
  marginTop: "0.5rem",
  transition: "background 0.2s ease, transform 0.15s ease",
};

const errorBoxStyle = {
  background: "#FDECEC",
  border: "1px solid #E8A8A8",
  borderRadius: "10px",
  padding: "0.65rem 0.9rem",
  fontSize: "0.88rem",
  color: "var(--error)",
  marginBottom: "1rem",
};

export default AdminLogin;
